<template>
  <div class="small-output-wrapper">
    <EmptyOutputMessage v-bind="props" />
    <UiChips
      class="chips"
      :options="sortedFilterChips"
      rightIcon="clear"
      small
      emit-value
      show-items-count
      @update:modelValue="emit('selectedChipId', $event)"
    />
  </div>
</template>

<script setup lang="ts">
  import { UiChips, type UiChipsProps } from '@experience/core-chips-ui';
  import { sortFilterChips } from '@/entities/filter/lib/sort';
  import EmptyOutputMessage from './message/EmptyOutputMessage.vue';

  export interface MessageProps {
    resultsCount: number;
  }

  type ChipsModelValue = UiChipsProps['modelValue'];

  const props = defineProps<MessageProps & UiChipsProps>();
  const emit = defineEmits<{ (e: 'selectedChipId', value: ChipsModelValue): void }>();

  const sortedFilterChips = computed(() => sortFilterChips(props.options));
</script>

<style scoped lang="scss">
  @use '@experience/shared/dist/assets/adaptivity' as adaptivity;

  .small-output-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 600px;
    margin: 80px auto 0;
    padding: 0 20px;

    @include adaptivity.tablet {
      margin: 56px auto 0;
    }
  }

  .chips {
    justify-content: center;
    margin-top: 16px;

    :deep(.ui-chip) {
      max-width: 280px;
    }

    :deep(.ui-chip__label-container) {
      max-width: calc(280px - var(--chip-padding-left) - var(--chip-padding-right));
    }

    :deep(.ui-chip__label) {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    // У чипсов со счётчиком многоточие добавляет сам счётчик — иначе оно дублируется
    :deep(.ui-chip--with-items-count .ui-chip__label) {
      text-overflow: clip;
    }
  }
</style>
